<template>
    <div v-if="dialog">
      <v-dialog
        v-model="dialog"
        :width="this.$vuetify.breakpoint.width >= 769 ? '40%' : '100%'"
        :persistent="false"
      >
        <div class="content">
          <v-tooltip bottom>
            <div slot="activator">
              <v-btn
                icon
                :style="`position: absolute; top: 5px; right: 0px;`"
                @click="close"
              >
                <v-icon
                  small
                  color="red"
                  style="font-size: 60px"
                >
                  close
                </v-icon>
              </v-btn>
              <a
                :href="link"
                target="_blank"
                @click="trackClick"
              >
                <img
                  :src="image"
                  alt="campanha"
                  class="center"
                >
              </a>
            </div>
            <span>Clique para saber mais</span>
          </v-tooltip>
        </div>
      </v-dialog>
    </div>
  </template>
  <script>
  export default {
    props: {
      dialog: { type: Boolean, required: true, default: false },
      isFree: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      image() {
        return '/assets/img/whatsapp_changed.jpg'
      },
      link() {
        return 'https://czap.me/OzjoCSM7KHZ2fRRDRUc'
      },
    },
    mounted() {
      if (this.dialog) {
        this.$mixpanel.track('View Banner', {
          free: this.isFree,
          image: this.image,
          link: this.link,
          description: this.description
        })
      }
    },
    methods: {
      close() {
        this.$emit('close')
      },
      trackClick() {
        this.$mixpanel.track('Click Banner', {
          free: this.isFree,
          image: this.image,
          link: this.link,
          description: this.description
        })
      }
    }
  }
  </script>
  <style scoped>
  .center {
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
  .v-card__text {
    padding: 0;
    margin: 0;
  }
  .v-dialog.v-dialog--active {
    padding: 0;
    margin: 0;
  }
  .content {
    position: relative;
    height: auto;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
  </style>
  